import {observer} from "mobx-react";
import {Navigate, Outlet} from "react-router-dom";
import {useAppDataStore} from "@/mobx/appDataStore.jsx";

export const PrivateRoute = observer(() => {
  const appDataStore = useAppDataStore()
  if (appDataStore.user) return (<Outlet/>)
  return <Navigate to="/auth" replace/>;
});
